function toggleFilters(target) {
    const panel = document.getElementById(target);
    if (panel) {
        panel.classList.toggle('show');
    }
}

const init = function () {

    const buttons = document.querySelectorAll('[data-toggle_filters]');
    if (buttons.length === 0) {
        return;
    }

    buttons.forEach(button => {
        const target = button.getAttribute('data-toggle_filters');
        button.addEventListener('click', (event) => {
            toggleFilters(target)
        });
    });

}
export default {init};
